import OwnerLocationDashboardResponseBase from './base/OwnerLocationDashboardResponseBase';

/**
 * @class OwnerLocationDashboardResponse
 * @extends OwnerLocationDashboardResponseBase
 */
class OwnerLocationDashboardResponse extends OwnerLocationDashboardResponseBase {

}

export default OwnerLocationDashboardResponse;
